module.exports = __webpack_public_path__ + "static/media/hint.ba2b9729.ogg";